// extracted by mini-css-extract-plugin
export default {"head":"TableProductHead_head__DOdzV","headColumn":"TableProductHead_headColumn__t5LGy","sortButtonContainer":"TableProductHead_sortButtonContainer__4Z2xY"};